<template>
	<JBox>
		<template v-if="form">
			<JBox class="s-w-full s-mb-8">
				<label class="s-w-full s-font-bold s-text-gray-500">Name</label>
				<!-- REFACTOR:THEME JTEXT SHOULD BE SPECIFIC VARIANT-->
				<JText class="s-text-gray-500 s-text-sm s-mb-1">This field will not be visible to customers</JText>
				<JInputText v-model="form.name" />
			</JBox>

			<JBox class="s-w-full s-mb-8">
				<label class="s-w-full s-font-bold s-text-gray-500">Description</label>
				<!-- REFACTOR:THEME JTEXT SHOULD BE SPECIFIC VARIANT-->
				<JText class="s-text-gray-500 s-text-sm s-mb-1">This field will not be visible to customers</JText>
				<JInputText v-model="form.description" />
			</JBox>

			<JBox class="s-w-full s-mb-8">
				<label class="s-w-full s-font-bold s-text-gray-500">Rule</label>
				<JRadios v-model="jsonLogicAst.type" :options="ruleTypesOptions" class="s-mb-2" />

				<!-- Flat -->
				<JBox v-if="jsonLogicAst.type === 'flat'">
					<JFlex>
						<JInputNumber v-model="jsonLogicAst.flat" placeholder="Amount" />
						<JSelect
							v-model="jsonLogicAst.currencyCode"
							@input="compileJsonLogic"
							:options="currencyCodeOptions"
							placeholder="Currency Code"
							class="s-ml-2"
						/>
					</JFlex>
				</JBox>

				<!-- Ratio -->
				<JFlex v-else-if="jsonLogicAst.type === 'ratio'" class="s-items-center">
					<JInputNumber v-model="jsonLogicAst.percentage" placeholder="Percentage" /><JBox class="s-ml-2">%</JBox>
				</JFlex>

				<!-- Custom -->
				<JBox v-else-if="jsonLogicAst.type === 'custom'">
					<CCodeEditor language="json" v-model="jsonLogicAst.custom" />
				</JBox>
			</JBox>

			<!-- Slot -->
			<slot :handleSave="handleSave" :handleCancel="handleCancel" :handleRemove="handleRemove" />
		</template>
	</JBox>
</template>

<script>
export default {
	props: {
		value: {
			type: Object,
			default: () => ({})
		}
	},

	data() {
		return {
			form: {},

			jsonLogicAst: {
				type: "", // flat, ratio, custom
				percentage: null,
				flat: null,
				currencyCode: "",
				custom: ""
			},

			ruleTypesOptions: [
				{ name: "Ratio", value: "ratio" },
				{ name: "Flat", value: "flat" },
				{ name: "Custom", value: "custom" }
			],

			currencyCodeOptions: [{ name: "HKD", value: "HKD" }]
		}
	},

	methods: {
		parseJsonLogic(item) {
			// 1: Get json

			let jsonLogicJson
			try {
				jsonLogicJson = item?.calculationLogic ? JSON.parse(item?.calculationLogic) : null
			} catch (e) {
				jsonLogicJson = null
			}

			// 2: Based on jsonLogic figure out what type it is and parse it
			// -------------------------------------------
			// Flat example
			// -------------------------------------------
			/*
			`[100, "HKD"]`
			*/

			// -------------------------------------------
			// Ratio example
			// -------------------------------------------
			/*
			{
        "*": [
          {
          	"var": "premium"
          },
          0.6
        ]
    	}
			*/

			let type

			if (!jsonLogicJson) type = null
			else if (jsonLogicJson?.["*"]?.[0]?.var === "premium") type = "ratio"
			else if (Array.isArray(jsonLogicJson)) type = "flat"
			else type = "custom"

			// 3: assign jsonLogicAst
			this.jsonLogicAst = {
				type,
				percentage: type === "ratio" ? parseFloat((jsonLogicJson?.["*"]?.[1] ?? 0) * 100).toFixed(2) : null,
				flat: type === "flat" ? jsonLogicJson?.[0] : null,
				currencyCode: type === "flat" ? jsonLogicJson?.[1] : null,
				custom: type === "custom" ? jsonLogicJson : null
			}
		},

		compileJsonLogic() {
			const jsonLogicAst = this.jsonLogicAst
			let compiled

			// Compile ratio
			if (jsonLogicAst?.type === "ratio")
				compiled = JSON.stringify({ "*": [{ var: "premium" }, parseFloat((jsonLogicAst?.percentage ?? 0) / 100).toFixed(2)] })

			// Compile flat
			if (jsonLogicAst?.type === "flat") compiled = JSON.stringify([jsonLogicAst.flat, jsonLogicAst.currencyCode])

			// Compile custom
			if (jsonLogicAst?.type === "custom") compiled = JSON.stringify(jsonLogicAst.custom)

			// Assign to item
			this.form.calculationLogic = compiled
		},

		handleSave() {
			this.compileJsonLogic()
			this.$emit("input", { ...this.form })
		},

		handleCancel() {
			this.$emit("cancel")
		},

		handleRemove() {
			this.$emit("remove", this.form)
		}
	},

	watch: {
		value: {
			handler(newVal) {
				this.parseJsonLogic(this.value)
				this.form = { ...newVal }
			},
			immediate: true,
			deep: true
		}
	}
}
</script>
